const PipsTerminalContentTwo = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="contact__cards row">
          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Unified Trading Dashboard</h4>
              </div>
              <p>
                Access all your assets, Forex, Crypto, Stocks, and Commodities,
                from a single, intuitive workspace. Seamless navigation means
                less complexity and more focus on strategy.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Smart Analytics Suite</h4>
              </div>
              <p>
                Leverage AI-driven data visualization, trend forecasts, and
                customizable performance metrics to make informed trading
                decisions.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Lightning-Fast Execution</h4>
              </div>
              <p>
                Execute trades within milliseconds, backed by stable servers and
                optimized order routing that ensures minimal slippage.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Personalized Learning Integration</h4>
              </div>
              <p>
                Access learning modules, tutorials, and mentorship insights
                directly within the terminal, empowering you to learn and trade
                simultaneously.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PipsTerminalContentTwo;
